module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper _modalWrapper_"
  }, [_c('div', {
    staticClass: "modal-container flexContainer"
  }, [_c('div', {
    staticClass: "modalBody"
  }, [_c('img', {
    staticClass: "cross fright abs pointer",
    attrs: {
      "src": require("../../../assets/croix.png"),
      "width": "20",
      "height": "20"
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modalContent txtCenter"
  }, [_c('h2', {
    staticClass: "ff-light"
  }, [_vm._v(_vm._s(_vm.$t("favorite.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("favorite.name")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "id": "favoriteName",
      "placeholder": "Favorite name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.save($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn block pointer center",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("favorite.save")))])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5efa12e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/dialog/AddFavorite.vue
// module id = 3377
// module chunks = 0